import React, { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import socket from "../../../../socket";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ChatList = ({ selectedChatId, onSelectChat, onInitialLoad }) => {
  const [chats, setChats] = useState([]);
  const currentUserEmail = localStorage.getItem("userEmail");
  const [onlineStatusMap, setOnlineStatusMap] = useState({});

  useEffect(() => {
    const fetchChats = async () => {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BACKEND_URL}/chats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      const enriched = (await Promise.all(
  data.chats.map(async (chat) => {
    const other = chat.participants?.find((e) => e !== currentUserEmail);

    if (!other) {
      console.warn("⚠️ No 'other' participant found in chat:", chat);
      return null; // ⚠️ Skip broken chat
    }

    const userRes = await fetch(`${BACKEND_URL}/user/${encodeURIComponent(other)}`);
    const userData = await userRes.json();

    const fullName = `${userData.firstName || ""} ${userData.lastName || ""}`.trim();
    const fallbackName = typeof other === "string" && other.includes("@")
      ? other.split("@")[0]
      : "Unknown";

    console.log("🔍 User Email:", other);
    console.log("🧾 Computed Full Name:", fullName);
    console.log("📛 Final Display Name:", fullName || fallbackName);

    return {
      ...chat,
      otherUserEmail: other,
      profileImage: userData.profileImage || "/person.png",
      name: fullName || fallbackName,
    };
  })
)).filter(Boolean); // ⛳ removes nulls


      enriched.sort((a, b) => {
        const timeA = a.lastMessageTime ? new Date(a.lastMessageTime.seconds * 1000).getTime() : 0;
        const timeB = b.lastMessageTime ? new Date(b.lastMessageTime.seconds * 1000).getTime() : 0;
        return timeB - timeA;
      });

      setChats(enriched);
      if (onInitialLoad && enriched.length > 0) {
        onInitialLoad(enriched[0].chatId);
      }
    };

    fetchChats();
  }, []);

  useEffect(() => {
    socket.on("user_online_status", ({ userEmail, isOnline }) => {
      setOnlineStatusMap((prev) => ({ ...prev, [userEmail]: isOnline }));
    });

    return () => {
      socket.off("user_online_status");
    };
  }, []);

  return (
  <div className="flex flex-col h-full overflow-hidden bg-white border-r border-gray-200">
    {/* 🔹 Sticky Header */}
    <div className="sticky top-0 z-10 bg-white px-4 py-3 border-b">
      <h2 className="text-lg font-semibold text-gray-800">Messages</h2>
    </div>

    {/* 🔸 Scrollable Chat List */}
    <div className="flex-1 overflow-y-auto divide-y divide-gray-100">
      {chats.map((chat) => (
        <div
          key={chat.chatId}
          onClick={() => onSelectChat(chat.chatId)}
          className={`flex items-center gap-3 p-4 cursor-pointer hover:bg-[#AFE5FF] ${
            selectedChatId === chat.chatId ? "bg-[#AFE5FF]" : ""
          }`}
        >
          {/* Avatar + Online */}
          <div className="relative shrink-0">
            <img
              src={chat.profileImage}
              alt="avatar"
              className="w-10 h-10 rounded-full object-cover"
            />
            <span
              className={`absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full ${
                onlineStatusMap[chat.otherUserEmail] ? "bg-green-500" : "bg-gray-400"
              }`}
            />
          </div>

          {/* Name + Message */}
          <div className="flex flex-col min-w-0 flex-1">
            <p className="text-sm font-medium text-gray-800 truncate">
              {chat.name}
            </p>
            <p className="text-xs text-gray-500 truncate">
              {chat.lastSender === currentUserEmail ? "You: " : ""}
              {chat.lastMessage ? chat.lastMessage.slice(0, 80) + (chat.lastMessage.length > 80 ? "..." : "") : "No message yet..."}
            </p>
          </div>

          {/* 🔵 Unread Dot */}
          {chat.unreadCount > 0 && chat.lastSender !== currentUserEmail && (
            <span className="w-2.5 h-2.5 bg-blue-500 rounded-full ml-auto"></span>
          )}
        </div>
      ))}
    </div>
  </div>
);


};

export default ChatList;
